// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import sommaire from './routes/sommaire';
import aboutUs from './routes/about';
import error404 from './routes/error404';
import client from './routes/client';

//Import big slides for menu responsive
import './bigSlide.js';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Page Sommaire
  sommaire,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  error404,

  client,

});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js